import React, { useContext } from 'react';
import { isDesktop, isMobile } from "react-device-detect";
import ReactPlayer from 'react-player';

//ads
import Caja3 from '../../ads/Caja3';

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Loading from '../common/Loading';
import EmptySpace from '../common/EmptySpace';

const Home = () => {

    const { dataGallery, loading } = useContext(GalleryContext);
    const { urlEspecialVideos, gallery, queryStringText, qryStrStart, title, epigraph, urlEspecial } = dataGallery;

    var videoWidth = 521;
    var videoHeight = 941;

    if(isMobile){
        videoWidth = 360;
        videoHeight = 'vh-100';
    }

    const firstPhoto = gallery ? (Object.keys(gallery)).shift() : '';

    return (
        loading
            ? <Loading /> 
            : <section className="mx-auto text-center container-titular">
                <a href={`${urlEspecial}${qryStrStart}${queryStringText}=${firstPhoto}`}>
                    <ReactPlayer
                        className="mx-auto"
                        url={`${urlEspecialVideos}video/portada.mp4`}
                        loop={true}
                        muted={true}
                        playing={true}
                        playsinline={true}
                        width={videoWidth}
                        height={videoHeight}
                    />
                </a>
                <h1 className="d-none">{title}</h1>
                <p className="d-none">{epigraph}</p>
                <section className="content-msgs">
                    {!isDesktop && <Caja3 />}        
                </section>      
                <EmptySpace />
            </section>
    )
}

export default Home
